import { clientApi } from "@/utils/api";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { TGetUserSettingResDto } from "@/api/services/main/user-setting/dtos/get-user-setting.dto";
import { TUpdateUserSettingReqDto, TUpdateUserSettingResDto } from "@/api/services/main/user-setting/dtos/update-user-setting.dto";

export const fetchUserSettingApi = async (): Promise<TGetUserSettingResDto> => {
  const { data } = await clientApi.get<TGetUserSettingResDto>("/user-setting");
  return data;
};

export const updateUserSettingApi = async (payload: TUpdateUserSettingReqDto): Promise<TUpdateUserSettingResDto> => {
  const { data } = await clientApi.put<TUpdateUserSettingResDto>("/user-setting", payload);
  return data;
};

export const createUserSettingApi = async (payload: TUpdateUserSettingReqDto): Promise<TUpdateUserSettingResDto> => {
  const { data } = await clientApi.post<TUpdateUserSettingResDto>("/user-setting", payload);
  return data;
};

export const useUserSetting = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.USER_SETTING.FETCH_DETAIL],
    queryFn: fetchUserSettingApi,
  });
};

export const useSaveUserSetting = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ payload, hasExistingSetting }: { payload: TUpdateUserSettingReqDto; hasExistingSetting: boolean }) =>
      hasExistingSetting ? updateUserSettingApi(payload) : createUserSettingApi(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.USER_SETTING.FETCH_DETAIL] });
      // Display name (userFullName) also drives the header/drawer via get-me — refresh it so the change reflects immediately.
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.USER.FETCH_ME] });
    },
  });
};
